(function(){
  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick" viewBox="0 0 20 20"><path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"></path></svg>';

  function addSecondLine(){
    var infos = document.querySelectorAll('.pickup-availability-info');
    var didWork = false;
    infos.forEach(function(info){
      if (info.dataset.secondLineAdded) return;
      var nameSpan = info.querySelector('.caption-large .color-foreground');
      if (!nameSpan) return;
      var shown = nameSpan.textContent.trim();
      var other = null, suffix = '';
      if (shown.indexOf('Pretoria') !== -1) { other = 'Puglia Cheese Cape Town'; suffix = ' (Somerset West)'; }
      else if (shown.indexOf('Cape Town') !== -1) { other = 'Puglia Cheese Pretoria'; }
      if (!other) return;

      info.dataset.secondLineAdded = 'true';
      didWork = true;

      var button = info.querySelector('#ShowPickupAvailabilityDrawer, .pickup-availability-button');
      if (button) button.textContent = 'Check Stores Address';

      var line = document.createElement('div');
      line.style.cssText = 'display:flex;align-items:center;gap:6px;margin-top:6px;';
      line.innerHTML = '<span class="svg-wrapper">' + CHECK_SVG + '</span>' +
        '<p class="caption-large" style="margin:0">Pickup available at <span class="color-foreground">' + other + suffix + '</span></p>';

      var readyLine = info.querySelector('.caption');
      if (readyLine) {
        info.insertBefore(line, readyLine);
      } else {
        info.appendChild(line);
      }
    });
    return didWork;
  }

  addSecondLine();
  var observer = new MutationObserver(function(){ addSecondLine(); });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function(){ observer.disconnect(); }, 30000);
})();
